import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import HelpCenter from "../components/HelpCenter";

const HelpCenterPage = () => {
  return (
    <>
      <Header />
      <HelpCenter />
      <Footer />
    </>
  );
};

export default HelpCenterPage;
